import slice from './coupon.slice';
export { addCoupon, deleteCoupon } from './coupon.slice';
export type { CouponPayload } from './coupon.slice';
export default slice.reducer;
